module.exports = __webpack_public_path__ + "img/horizontal_3_4_3009.7a6e3a91.png";